<template>
    <div class="modal">
        <h2>Mu clásico</h2>
        <p>MUCRISIS uno de los mejores servidores clásicos de Mu Online, juega a la vieja escuela y recuerda viejos momentos de este entretenido juego.</p>
        <h2>Mu Online 97d</h2>
        <p>Jugar servidor de Mu Online versión 97d, con ítems 99b.</p>
        <h2>Servidor de Mu Online</h2>
        <p>El mejor servidor de Mu Online justo aquí. ¿Qué esperas para jugar?</p>
        <h2>Mu 24/7 - Siempre activo</h2>
        <p>Siempre activo, juega a todo el día, servidor de Mu Online abierto las 24 horas del dia, los 7 dias de la semana.</p>
        <h2>Un Mu dificil</h2>
        <p>Este juego no esta hecho para cualquiera, nuestro servidor de Mu Online tiene todo tipo de retos que te harán querer quedarte horas y horas de juego sin descanso.</p>
        <h2>Un Mu con amable comunidad</h2>
        <p>En nuestro servidor de Mu Online los jugadores siempre estan dispuestos a ayudar a los nuevos.</p>
        <h2>Regalo de bienvenida al Mu</h2>
        <p>A todo el que se registre y verifique su email será recompensado con un set +11 de bienvenida!</p>
    </div>
</template>

<script>
export default {
    name:'KeyWordModal'
}
</script>

<style>

</style>